let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aNcBc")).then(() => parcelRequire('3ac4b'));